import createIcon from '../../createIcon';

/**
 * @component @name SensorWindow
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNFYyMEg2VjRIMThaTTE4IDJINkM0LjkgMiA0IDIuOSA0IDRWMjBDNCAyMS4xIDQuOSAyMiA2IDIySDE4QzE5LjEgMjIgMjAgMjEuMSAyMCAyMFY0QzIwIDIuOSAxOS4xIDIgMTggMlpNNyAxOUgxN1YxM0g3VjE5Wk0xMCAxMEgxNFYxMUgxN1Y1SDdWMTFIMTBWMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SensorWindow = createIcon('SensorWindow', [
  [
    'path',
    {
      d: 'M18 4V20H6V4H18ZM18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM7 19H17V13H7V19ZM10 10H14V11H17V5H7V11H10V10Z',
      key: '1e6876',
    },
  ],
]);

export default SensorWindow;
